import { Typography } from '@mui/material'
import { DataGrid, GridColDef, GridToolbarContainer, gridClasses } from '@mui/x-data-grid'
import { format } from 'date-fns'
import React, { useCallback, useEffect } from 'react'
import api from '../../api'
import ExportDialog from '../../components/ExportDialog'
import { DATETIME_FORMAT, DEVICE_DETAIL_INTERVAL } from '../../constants'
import { useAsync } from '../../hooks'

const CustomToolbar = ({ id }: { id: string }) => {
    return (
        <GridToolbarContainer className={gridClasses.toolbarContainer}>
            <ExportDialog
                id={id}
                fetchData={api.getDeviceTowers}
                filename="towers"
                fields={['created', 'networkRaw', 'availableNetworksRaw']}
                headers={['Date', 'Connected Network', 'Available Networks']}
            />
        </GridToolbarContainer>
    )
}

const TowerTable = ({ deviceId }: { deviceId?: string }) => {
    const [page, setPage] = React.useState(0)
    const [pageSize, setPageSize] = React.useState(10)

    const fetchDeviceTowers = useCallback(
        () => api.getDeviceTowers(deviceId, { limit: pageSize, offset: page * pageSize }),
        [deviceId, page, pageSize]
    )
    const { value: towersResponse, status, execute } = useAsync(fetchDeviceTowers)
    const towers = towersResponse?.results || []

    useEffect(() => {
        const intervalId = setInterval(() => {
            execute()
        }, DEVICE_DETAIL_INTERVAL)

        return () => clearInterval(intervalId)
    }, [execute])

    const columns: GridColDef[] = [
        { field: 'id', hide: true },
        {
            field: 'created',
            headerName: 'Date',
            flex: 1,
            sortable: false,
            valueFormatter: (params: any) => format(new Date(params.value as string), DATETIME_FORMAT),
        },
        { field: 'networkRaw', headerName: 'Connected Network', flex: 1, sortable: false },
        { field: 'availableNetworksRaw', headerName: 'Available Networks', flex: 1, sortable: false },
    ]

    if (!towersResponse?.count) {
        return null;
    }

    return (
        <>
            <Typography variant="h6" p={1}>
                Cell ID
            </Typography>
            <div style={{ height: 490 }}>
                <DataGrid
                    disableColumnMenu
                    rowHeight={34}
                    columns={columns}
                    rows={towers}
                    pagination
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowCount={towersResponse?.count}
                    rowsPerPageOptions={[10, 20, 30, 50]}
                    paginationMode="server"
                    onPageChange={(newPage) => setPage(newPage)}
                    loading={status === 'pending'}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    componentsProps={{
                        toolbar: { id: deviceId },
                    }}
                />
            </div>
        </>
    )
}

export default TowerTable
